import Styled from 'styled-components'

export const HeaderHeight = Styled.header`
`
export const HeaderMenu = Styled.div`
`

export const Space = Styled.div`
`
export const Margin = Styled.div`
`

export const Logo = Styled.img`
`
